import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import { makeAirbrakeErrorLink } from '@ui/lib/airbrake/apolloErrorLink'

import { getClientId, getSessionId } from '@website/utils/session'

const NEXT_PUBLIC_GRAPHQL_API_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_API_ENDPOINT

if (!NEXT_PUBLIC_GRAPHQL_API_ENDPOINT) {
  throw new Error(
    'Environment variable NEXT_PUBLIC_GRAPHQL_API_ENDPOINT is not defined!',
  )
}

export const initializeApollo = () => {
  const authLink = setContext((_, { headers }) => {
    if (typeof window === 'undefined') return { headers }
    const clientId = getClientId()
    const sessionId = getSessionId()
    return {
      headers: {
        ...headers,
        ...(clientId ? { 'X-Client-Udid': clientId } : {}),
        ...(sessionId ? { 'X-Session-Id': sessionId } : {}),
      },
    }
  })

  const httpLink = new HttpLink({
    uri: NEXT_PUBLIC_GRAPHQL_API_ENDPOINT,
  })

  // Reports every failed operation to Airbrake (was console-only). Both of
  // this app's operations take id/enum-only variables (placement id, user
  // uuid), so both are variable-safe.
  const errorLink = makeAirbrakeErrorLink({
    variableSafeOperations: [
      'PublicOffersForPlacement',
      'PublicOffersForPlacementPartnerLinks',
    ],
  })

  const link = ApolloLink.from([authLink, errorLink, httpLink])

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
    ssrMode: typeof window === 'undefined',
  })
}
